import * as types from '../actions/actionTypes';

const defaultState = {
  history: [],
  pagination: {},
  loading: false,
};

export default (state = defaultState, action) => {
  const nextState = Object.assign({}, state);

  switch (action.type) {
    case types.GET_KARMA_SUCCESS:
      return { ...state, ...action.data };
    case types.GET_KARMA_HISTORY:
      return { ...state, loading: true };
    case types.GET_KARMA_HISTORY_SUCCESS:
      return { ...state, ...action.data, loading: false };
    default:
      return nextState;
  }
};
